import { setup } from "xstate";

export enum HealthHistoryState {
  Dashboard = "dashboard",
  BMIScreen = "bmiScreen",
  BMIUpdateForm = "bmiUpdateForm",
  Questionnaire = "questionnaire",
}

export const healthHistoryEventNames = {
  OPEN_BMI: "OPEN_BMI",
  OPEN_BMI_FORM: "OPEN_BMI_FORM",
  BACK: "BACK",
  OPEN_QUESTIONNAIRE: "OPEN_QUESTIONNAIRE",
  BACK_TO_DASHBOARD: "BACK_TO_DASHBOARD",
};

export const healthHistoryMachine = setup({
  types: {} as { context: Record<string, never> },
}).createMachine({
  id: "healthHistory",
  initial: HealthHistoryState.Dashboard,
  context: {},
  states: {
    [HealthHistoryState.Dashboard]: {
      on: {
        [healthHistoryEventNames.OPEN_BMI]: {
          target: HealthHistoryState.BMIScreen,
        },
        [healthHistoryEventNames.OPEN_BMI_FORM]: {
          target: HealthHistoryState.BMIUpdateForm,
        },
        [healthHistoryEventNames.OPEN_QUESTIONNAIRE]: {
          target: HealthHistoryState.Questionnaire,
        },
      },
    },
    [HealthHistoryState.BMIScreen]: {
      on: {
        [healthHistoryEventNames.BACK]: {
          target: HealthHistoryState.Dashboard,
        },
      },
    },
    [HealthHistoryState.BMIUpdateForm]: {
      on: {
        [healthHistoryEventNames.BACK]: {
          target: HealthHistoryState.Dashboard,
        },
        [healthHistoryEventNames.BACK_TO_DASHBOARD]: {
          target: HealthHistoryState.Dashboard,
        },
      },
    },
    [HealthHistoryState.Questionnaire]: {
      on: {
        [healthHistoryEventNames.BACK_TO_DASHBOARD]: {
          target: HealthHistoryState.Dashboard,
        },
      },
    },
  },
});
